/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { Login } from './userSlice';

export interface LoginErrorModalProps {
  login: Login;
  onClose: () => void;
}

function LoginErrorModal({ login, onClose }: LoginErrorModalProps) {
  if (!login.errorModalOpen) return null;
  console.log('LoginErrorModal', login);
  return (
    <Dialog
      open={login.errorModalOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogContent>
        <DialogTitle id="modal-modal-title" variant="h6" component="h2">
          Something went wrong...
        </DialogTitle>
        <Typography component={'span'} id="modal-modal-description" sx={{ mt: 2 }}>
          <p>
            {login.fromSmartFhirCookie
              ? 'Sorry, there was a problem logging you in through Epic.'
              : 'Sorry, there was a problem logging you in.'}
          </p>
          {login.errors ? (
            login.errors.map((error, index) => {
              const ariaControls = `panel${index}a-content`;
              const headerId = `panel${index}a-header`;
              return error.detail ? (
                <Accordion key={index.toString()} elevation={0} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={ariaControls} id={headerId}>
                    <Typography>{error.title}</Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ fontStyle: 'oblique', color: 'error.main' }}>
                    <Typography variant="body2">{error.detail}</Typography>
                    <br />
                    <Typography>
                      Suggestion: Please close this window and try signing in again from the{' '}
                      <a href="/">MedPearl home page</a>. If you are still having issues, please contact{' '}
                      <a href="mailto:medpearlsupport@healthendeavors.com">medpearlsupport@healthendeavors.com</a>.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ) : (
                <Accordion key={index.toString()} elevation={0} disableGutters>
                  <AccordionSummary sx={{ pointerEvents: 'none' }}>
                    <Typography>{error.title}</Typography>
                  </AccordionSummary>
                </Accordion>
              );
            })
          ) : (
            <p>We've encountered an unexpected error.</p>
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LoginErrorModal;
